<template>
  <router-view />
</template>

<script>
export default {
  data () {
    return {
      pageTitle: 'Carrier Configuration',
      breadcrumb:
      {
        name: 'Configurations',
        route: { name: 'manage-carriers-carrier-configurations' }
      },
      sidebar:
      [
        {
          icon: ['fal', 'address-card'],
          route: { name: 'manage-carriers-carrier-configurations-detail' },
          name: 'Detail'
        },
        {
          icon: ['fal', 'tools'],
          route: { name: 'manage-carriers-carrier-configurations-label' },
          name: 'Label'
        },
        {
          icon: ['fal', 'envelope-open-dollar'],
          route: { name: 'manage-carriers-carrier-configurations-consignment' },
          name: 'Consignment'
        },
        {
          icon: ['fal', 'file-signature'],
          route: { name: 'manage-carriers-carrier-configurations-manifest' },
          name: 'Manifest'
        },
        {
          icon: ['fal', 'tools'],
          route: { name: 'manage-carriers-carrier-configurations-edi' },
          name: 'EDI'
        },
        {
          icon: ['fal', 'map-marked-alt'],
          route: { name: 'manage-carriers-carrier-configurations-tracking' },
          name: 'Tracking'
        },
        {
          icon: ['fal', 'handshake'],
          route: { name: 'manage-carriers-carrier-configurations-terms' },
          name: 'Terms'
        },
        {
          icon: ['fal', 'file-invoice-dollar'],
          route: { name: 'manage-carriers-carrier-configurations-invoice' },
          name: 'Invoice'
        },
        {
          icon: ['fal', 'truck'],
          route: { name: 'manage-carriers-carrier-configurations-pickup' },
          name: 'Pickup'
        }
      ]
    }
  }
}
</script>
